// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__gc8P3","content":"style_content__rL0UN","duration":"style_duration__8b+fv","footer":"style_footer__eIcLQ","map":"style_map__YXQat"};